import MinimizableWebChat from "./component";

export default MinimizableWebChat;
